import { MODES_DE_COMMANDE } from "@/utils/mode-commande";

export const widgetPlanningTabProps = () => ({
    modeCommande: {
      type: Object,
      required: true
    },
    communeLad: {
      type: Object,
      required: false
    },
    magasin: {
      type: Object,
      required: false,
      default: () => []
    }
})

export const useWidgetPlanningTab = (props) => {
  const commune = ref(null)
  const dispoPremierCreneau = ref(null)
  const finDispoPremierCreneau = ref(null)
  const currentServiceId = ref(null)
  
  const services = computed(() => {
    return props.modeCommande.services ? props.modeCommande.services : [];
  });


  const currentService =  computed(() => {
    if (currentServiceId.value) {
      return services.value.find((service) => {
        return parseInt(service.id) === parseInt(currentServiceId.value);
      })
    }
    return null
  });
  const hasGps = computed(() => {
    return currentService.value && currentService.value.gps && currentService.value.gps.latitude && currentService.value.gps.longitude;
  });
  const gpsLink = computed(() =>{
    if (hasGps.value) {
      return `https://www.google.com/maps/search/?api=1&query=${currentService.value.gps.latitude},${currentService.value.gps.longitude}`;
    }
    return "";
  });

  const selectCommune = (communeSelected) => {
    commune.value = communeSelected;
  }
  const resetCommune = () => {
    commune.value = null;
  }
  const planningDisplayed = (planning) => {
    dispoPremierCreneau.value = planning.meta.dispoPremierCreneau;
    if (planning.meta.finDispoPremierCreneau !== "indisponible") {
      finDispoPremierCreneau.value = planning.meta.finDispoPremierCreneau;
    }
  }
  const planningError = () => {
    dispoPremierCreneau.value = null;
    finDispoPremierCreneau.value = null;
  }

  watch(() => props.modeCommande, (val) => {
    if (val && !currentServiceId.value) {
      currentServiceId.value = val.services[0].id;
    }
  }, { immediate: true })

  watch(() => props.communeLad, (val) => {
    commune.value = val;
  }, { immediate: true })


  return {
    MODES_DE_COMMANDE,
    commune,
    dispoPremierCreneau,
    finDispoPremierCreneau,
    currentServiceId,
    services,
    currentService,
    hasGps,
    gpsLink,
    selectCommune,
    resetCommune,
    planningDisplayed,
    planningError
  }
}
